export const NUMERIC_PROPERTIES = ['number', 'duration', 'currency', 'percent'];